// source: exOrderInfo.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.common.model.ExFullOrderInfo', null, global);
goog.exportSymbol('proto.common.model.ExOrderInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExOrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExOrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExOrderInfo.displayName = 'proto.common.model.ExOrderInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.model.ExFullOrderInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.model.ExFullOrderInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.model.ExFullOrderInfo.displayName = 'proto.common.model.ExFullOrderInfo';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExOrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExOrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExOrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExOrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
intid: jspb.Message.getFieldWithDefault(msg, 2, 0),
symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
optype: jspb.Message.getFieldWithDefault(msg, 4, ""),
type: jspb.Message.getFieldWithDefault(msg, 5, ""),
side: jspb.Message.getFieldWithDefault(msg, 6, ""),
price: jspb.Message.getFieldWithDefault(msg, 7, ""),
size: jspb.Message.getFieldWithDefault(msg, 8, ""),
funds: jspb.Message.getFieldWithDefault(msg, 9, ""),
dealfunds: jspb.Message.getFieldWithDefault(msg, 10, ""),
dealsize: jspb.Message.getFieldWithDefault(msg, 11, ""),
timeinforce: jspb.Message.getFieldWithDefault(msg, 12, ""),
postonly: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
iceberg: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
visiblesize: jspb.Message.getFieldWithDefault(msg, 16, ""),
cancelafter: jspb.Message.getFieldWithDefault(msg, 17, 0),
clientoid: jspb.Message.getFieldWithDefault(msg, 18, ""),
isactive: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
cancelexist: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
createdat: jspb.Message.getFieldWithDefault(msg, 21, 0),
tradetype: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExOrderInfo}
 */
proto.common.model.ExOrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExOrderInfo;
  return proto.common.model.ExOrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExOrderInfo}
 */
proto.common.model.ExOrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIntid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptype(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSize(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealfunds(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealsize(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeinforce(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPostonly(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIceberg(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisiblesize(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancelafter(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientoid(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactive(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelexist(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedat(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradetype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExOrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExOrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIntid();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptype();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSize();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getFunds();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDealfunds();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDealsize();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getTimeinforce();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getPostonly();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getIceberg();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getVisiblesize();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCancelafter();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getClientoid();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIsactive();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getCancelexist();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getCreatedat();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getTradetype();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 intId = 2;
 * @return {number}
 */
proto.common.model.ExOrderInfo.prototype.getIntid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setIntid = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string opType = 4;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getOptype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setOptype = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string type = 5;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string side = 6;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string price = 7;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string size = 8;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setSize = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string funds = 9;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string dealFunds = 10;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getDealfunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setDealfunds = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string dealSize = 11;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getDealsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setDealsize = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string timeInForce = 12;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getTimeinforce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setTimeinforce = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool postOnly = 13;
 * @return {boolean}
 */
proto.common.model.ExOrderInfo.prototype.getPostonly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setPostonly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool hidden = 14;
 * @return {boolean}
 */
proto.common.model.ExOrderInfo.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool iceberg = 15;
 * @return {boolean}
 */
proto.common.model.ExOrderInfo.prototype.getIceberg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setIceberg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string visibleSize = 16;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getVisiblesize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setVisiblesize = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 cancelAfter = 17;
 * @return {number}
 */
proto.common.model.ExOrderInfo.prototype.getCancelafter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setCancelafter = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string clientOid = 18;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getClientoid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setClientoid = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional bool isActive = 19;
 * @return {boolean}
 */
proto.common.model.ExOrderInfo.prototype.getIsactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setIsactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool cancelExist = 20;
 * @return {boolean}
 */
proto.common.model.ExOrderInfo.prototype.getCancelexist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setCancelexist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional int64 createdAt = 21;
 * @return {number}
 */
proto.common.model.ExOrderInfo.prototype.getCreatedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string tradeType = 22;
 * @return {string}
 */
proto.common.model.ExOrderInfo.prototype.getTradetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExOrderInfo} returns this
 */
proto.common.model.ExOrderInfo.prototype.setTradetype = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.model.ExFullOrderInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.common.model.ExFullOrderInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.model.ExFullOrderInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExFullOrderInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
optype: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, ""),
side: jspb.Message.getFieldWithDefault(msg, 5, ""),
price: jspb.Message.getFieldWithDefault(msg, 6, ""),
size: jspb.Message.getFieldWithDefault(msg, 7, ""),
funds: jspb.Message.getFieldWithDefault(msg, 8, ""),
dealfunds: jspb.Message.getFieldWithDefault(msg, 9, ""),
dealsize: jspb.Message.getFieldWithDefault(msg, 10, ""),
fee: jspb.Message.getFieldWithDefault(msg, 11, ""),
feecurrency: jspb.Message.getFieldWithDefault(msg, 12, ""),
stp: jspb.Message.getFieldWithDefault(msg, 13, ""),
stop: jspb.Message.getFieldWithDefault(msg, 14, ""),
stoptriggered: jspb.Message.getBooleanFieldWithDefault(msg, 15, false),
stopprice: jspb.Message.getFieldWithDefault(msg, 16, ""),
timeinforce: jspb.Message.getFieldWithDefault(msg, 17, ""),
postonly: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 19, false),
iceberg: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
visiblesize: jspb.Message.getFieldWithDefault(msg, 21, ""),
cancelafter: jspb.Message.getFieldWithDefault(msg, 22, 0),
channel: jspb.Message.getFieldWithDefault(msg, 23, ""),
clientoid: jspb.Message.getFieldWithDefault(msg, 24, ""),
remark: jspb.Message.getFieldWithDefault(msg, 25, ""),
tags: jspb.Message.getFieldWithDefault(msg, 26, ""),
isactive: jspb.Message.getBooleanFieldWithDefault(msg, 27, false),
cancelexist: jspb.Message.getBooleanFieldWithDefault(msg, 28, false),
createdat: jspb.Message.getFieldWithDefault(msg, 29, 0),
tradetype: jspb.Message.getFieldWithDefault(msg, 30, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.model.ExFullOrderInfo}
 */
proto.common.model.ExFullOrderInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.model.ExFullOrderInfo;
  return proto.common.model.ExFullOrderInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.model.ExFullOrderInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.model.ExFullOrderInfo}
 */
proto.common.model.ExFullOrderInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptype(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSide(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSize(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFunds(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealfunds(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDealsize(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setFee(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setFeecurrency(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setStp(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setStop(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStoptriggered(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setStopprice(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimeinforce(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPostonly(value);
      break;
    case 19:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIceberg(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setVisiblesize(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancelafter(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setChannel(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientoid(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemark(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setTags(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsactive(value);
      break;
    case 28:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCancelexist(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedat(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradetype(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.model.ExFullOrderInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.model.ExFullOrderInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.model.ExFullOrderInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.model.ExFullOrderInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOptype();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSide();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPrice();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSize();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFunds();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDealfunds();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDealsize();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFee();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getFeecurrency();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getStp();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getStop();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getStoptriggered();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
  f = message.getStopprice();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTimeinforce();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPostonly();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      19,
      f
    );
  }
  f = message.getIceberg();
  if (f) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getVisiblesize();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCancelafter();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getChannel();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getClientoid();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getRemark();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getTags();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getIsactive();
  if (f) {
    writer.writeBool(
      27,
      f
    );
  }
  f = message.getCancelexist();
  if (f) {
    writer.writeBool(
      28,
      f
    );
  }
  f = message.getCreatedat();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getTradetype();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string opType = 3;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getOptype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setOptype = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string type = 4;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string side = 5;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getSide = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setSide = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string price = 6;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getPrice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setPrice = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string size = 7;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getSize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setSize = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string funds = 8;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string dealFunds = 9;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getDealfunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setDealfunds = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string dealSize = 10;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getDealsize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setDealsize = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string fee = 11;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getFee = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setFee = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string feeCurrency = 12;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getFeecurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setFeecurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string stp = 13;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getStp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setStp = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string stop = 14;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getStop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setStop = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional bool stopTriggered = 15;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getStoptriggered = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setStoptriggered = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};


/**
 * optional string stopPrice = 16;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getStopprice = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setStopprice = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string timeInForce = 17;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getTimeinforce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setTimeinforce = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool postOnly = 18;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getPostonly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setPostonly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional bool hidden = 19;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 19, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 19, value);
};


/**
 * optional bool iceberg = 20;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getIceberg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setIceberg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 20, value);
};


/**
 * optional string visibleSize = 21;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getVisiblesize = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setVisiblesize = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int64 cancelAfter = 22;
 * @return {number}
 */
proto.common.model.ExFullOrderInfo.prototype.getCancelafter = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setCancelafter = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional string channel = 23;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getChannel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setChannel = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string clientOid = 24;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getClientoid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setClientoid = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string remark = 25;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getRemark = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setRemark = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string tags = 26;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getTags = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setTags = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional bool isActive = 27;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getIsactive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setIsactive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 27, value);
};


/**
 * optional bool cancelExist = 28;
 * @return {boolean}
 */
proto.common.model.ExFullOrderInfo.prototype.getCancelexist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 28, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setCancelexist = function(value) {
  return jspb.Message.setProto3BooleanField(this, 28, value);
};


/**
 * optional int64 createdAt = 29;
 * @return {number}
 */
proto.common.model.ExFullOrderInfo.prototype.getCreatedat = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setCreatedat = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional string tradeType = 30;
 * @return {string}
 */
proto.common.model.ExFullOrderInfo.prototype.getTradetype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.model.ExFullOrderInfo} returns this
 */
proto.common.model.ExFullOrderInfo.prototype.setTradetype = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


goog.object.extend(exports, proto.common.model);
